export { default } from './otp-form';
